import React from "react";
import ThemeToggle from "../ui/ThemeToggle";
import NavDropdown from "./NavDropdown";
import { NAV_LINKS } from "./navConfig";

const NavDesktop = ({ onLinkClick }) => (
  <nav className="hidden xl:flex items-center gap-4 2xl:gap-5 whitespace-nowrap">
    {NAV_LINKS.map((l) => {
      if (l.variant === "dropdown") {
        return <NavDropdown key={l.id} link={l} onLinkClick={onLinkClick} />;
      }
      const isRoute = Boolean(l.route);
      const href = isRoute ? l.route : `#${l.id}`;
      const handleClick = (e) => {
        if (!isRoute) e.preventDefault();
        onLinkClick(l);
      };
      return (
        <a
          key={l.id}
          data-testid={`nav-link-${l.id}`}
          href={href}
          onClick={handleClick}
          className="nav-link text-[10.5px] xl:text-[11px] tracking-[0.18em] 2xl:tracking-[0.22em] uppercase"
        >
          {l.label}
        </a>
      );
    })}
    <ThemeToggle />
  </nav>
);

export default NavDesktop;
